import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import ActivitiesTypes from "./ActivitiesTypes";
import ActivitiesList from "./ActivitiesList";

const ActivityTab = ({ userId, fullName }: { userId: string; fullName: string }) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "activity",
  });

  return (
    <Box
      sx={{
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        background: "var(--White, #FFF)",
        padding: "20px",
      }}
    >
      <Typography
        sx={{
          color: "var(--black-100, #1C1C1C)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "24px",
          marginBottom: "24px",
        }}
      >
        {t("allActivity")}
      </Typography>
      <ActivitiesTypes />
      <ActivitiesList userId={userId} fullName={fullName} />
    </Box>
  );
};

export default ActivityTab;
